import { render } from "./EditPriceGroupItemView.vue?vue&type=template&id=1bba1040"
import script from "./EditPriceGroupItemView.vue?vue&type=script&lang=js"
export * from "./EditPriceGroupItemView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__